export default "__VITE_ASSET__DktB3qwh__"